import { render, staticRenderFns } from "./service5.vue?vue&type=template&id=43ac33ac&scoped=true&"
import script from "./service5.vue?vue&type=script&lang=js&"
export * from "./service5.vue?vue&type=script&lang=js&"
import style0 from "./service5.vue?vue&type=style&index=0&id=43ac33ac&prod&scoped=true&lang=css&"
import style1 from "./service5.vue?vue&type=style&index=1&id=43ac33ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ac33ac",
  null
  
)

export default component.exports